import {
  activityBaseApi,
  ActivityTags,
} from "activity/redux/api/activityBaseApi";
import { queryGenerator } from "activity/sub_modules/areatranfers/api/AreasTransfer.api";
import ISearchApi from "commonFnBcode/types/search.rtk";

export const activitySearchRtk = activityBaseApi.injectEndpoints({
  endpoints: (build) => ({
    //=============================== Fetch Queue =====================================
    fetchActivites: build.query<
      ISearchApi["fetchActivities"]["response"],
      ISearchApi["fetchActivities"]["payload"]
    >({
      query: (query) =>
        `activities/searchActivitiesByCityId?${queryGenerator(query)}`,
      providesTags: [ActivityTags.getActivity],
    }),
    addActivityImage: build.mutation<
      ISearchApi["addActivityImage"]["response"],
      ISearchApi["addActivityImage"]["payload"]
    >({
      query: (formData) => {
        return {
          url: `activities/addActivityImage`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [ActivityTags.getActivity],
    }),
    deleteActivityImage: build.mutation<
      ISearchApi["deleteActivityImage"]["response"],
      ISearchApi["deleteActivityImage"]["payload"]
    >({
      query: ({ activityImageId }) => {
        return {
          url: `activities/deleteActivityImage`,
          method: "POST",
          body: { activityImageId },
        };
      },
      invalidatesTags: [ActivityTags.getActivity],
    }),
    updateTourOptionAndImageOrder: build.mutation<
      ISearchApi["updateTourOptionAndImageOrder"]["response"],
      ISearchApi["updateTourOptionAndImageOrder"]["payload"]
    >({
      query: (body) => {
        return {
          url: `activities/updateTourOptionAndImageOrder`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [ActivityTags.getActivity],
    }),
    updateActivity: build.mutation<
      ISearchApi["updateActivity"]["response"],
      ISearchApi["updateActivity"]["payload"]
    >({
      query: (body) => {
        return {
          url: `activities/updateActivity`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [ActivityTags.getActivity],
    }),
  }),
  overrideExisting: false,
});
